import { useTranslationRef } from '@backstage/frontend-plugin-api';
import { Badge } from '@backstage/ui';
import { AccessResourceStatus } from 'adp-access-common';
import { accessTranslationRef } from '../translation';
import styles from './AccessStatusChip.module.css';

function getPhase(status: AccessResourceStatus | undefined): string {
  return status?.phase ?? 'pending';
}

export type AccessStatusTone = 'success' | 'warning' | 'danger' | 'default';

export function getAccessStatusTone(phase: string): AccessStatusTone {
  if (phase === 'ready' || phase === 'completed') {
    return 'success';
  }

  if (
    phase === 'pending' ||
    phase === 'reconciling' ||
    phase === 'deleting' ||
    phase === 'running' ||
    phase === 'accepted'
  ) {
    return 'warning';
  }

  if (phase === 'failed' || phase === 'delete_failed' || phase === 'aborted') {
    return 'danger';
  }

  return 'default';
}

export const AccessStatusChip = ({
  status,
}: {
  status: AccessResourceStatus | undefined;
}) => {
  const { t } = useTranslationRef(accessTranslationRef);
  const phase = getPhase(status);
  const tone = getAccessStatusTone(phase);
  const label =
    (
      {
        pending: t('status.pending'),
        ready: t('status.ready'),
        completed: t('status.completed'),
        reconciling: t('status.reconciling'),
        deleting: t('status.deleting'),
        running: t('status.running'),
        accepted: t('status.accepted'),
        failed: t('status.failed'),
        delete_failed: t('status.delete_failed'),
        aborted: t('status.aborted'),
      } as Record<string, string>
    )[phase] ?? phase;

  return (
    <Badge className={`${styles.statusChip} ${styles[tone]}`}>{label}</Badge>
  );
};
